import React from "react";
import { store } from "../../../../../redux/store";
import { heights } from "../../../../../styles/romeu/heights";
import { widths } from "../../../../../styles/romeu/widths";
import { MasterMerchandiseCategoryList } from "./list/list";
import { setMerchandiseCategoryOptions } from "../../../../../redux/reducers/catalog/catalog";
import { resetMasterMerchandiseCategoryList } from "../../../../../redux/reducers/resources/master/merchandiseCategory/list";

export class MasterMerchandiseCategoryContainer extends React.Component {
    componentWillUnmount(): void {
        store.dispatch(resetMasterMerchandiseCategoryList());
        store.dispatch(setMerchandiseCategoryOptions([]));
    }

    render(): React.ReactNode {
        return (
            <MasterMerchandiseCategoryList
                widthPopUp={widths.master.default}
                heigthPopUp={heights.master.default}
            />
        );
    }
}
